import React from 'react';
import { Card } from 'antd';

import API from '../../../helper/api';

import Pagination from '../../Pagination';
import DeviceDataTable from './DeviceDataTable';

class DeviceList extends React.Component {
  state = {
    data: [],
    isLoading: true
  };

  saveData = (data, isLoading) => {
    // save data from pagination
    this.setState({ data, isLoading });
  };

  render() {
    const { data, isLoading } = this.state;
    return (
      <Card>
        <Pagination path={API.device.list} saveData={this.saveData} />
        <DeviceDataTable data={data} isLoading={isLoading} />
      </Card>
    );
  }
}

export default DeviceList;
